<template>
  <v-card v-if="accountData != null" flat class="pa-3 mt-2">
    <v-card-text class="d-flex">
      <!-- upload photo -->
      <div>
        <avatar-image-component :edit="adminProfileStore.id == accountData.id" :avatarUrl="accountData.avatar"
          :user="accountData"></avatar-image-component>
      </div>
    </v-card-text>
    <v-card-text>
      <v-form ref="form" v-model="valid" class="multi-col-validation mt-6" lazy-validation>
        <v-row>
          <v-col md="6" cols="12">
            <v-text-field v-model="accountData.name" label="Name" dense outlined required
              :rules="nameRules"></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="accountData.email" label="E-mail"
              :disabled="accountData.id != 1 && userType !== 'student'" dense outlined required
              :rules="emailRules"></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-select disabled v-model="accountData.role_id" dense outlined label="Role" :items="roles" item-text="role"
              item-value="value"></v-select>
          </v-col>

          <v-col cols="12" md="6">
            <v-select v-model="accountData.status_id" :disabled="accountData.id == 1" dense outlined label="Status"
              :items="statuses" item-text="status" item-value="value"></v-select>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="accountData.address" outlined dense label="Address"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="accountData.region" outlined dense label="Region"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="accountData.city" outlined dense label="City"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="accountData.tel_number" outlined dense label="Phone"
              :rules="phoneRules"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'student'">
            <v-text-field v-model="accountData.student_identification" outlined dense label="Student ID"></v-text-field>
          </v-col>
          <v-col cols="12" md="6"
            v-else-if="userType == 'school' || (userType == 'guardian' && accountData.role_id == 4)">
            <v-text-field v-model="accountData.balance" :disabled="userType == 'guardian' && accountData.role_id == 4"
              outlined dense label="Balance"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="userType == 'school'">
            <v-text-field v-model="accountData.facility_name" outlined dense label="Facility Name"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="userType == 'school'">
            <v-text-field v-model="accountData.zipcode" outlined dense label="Zipcode"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="userType == 'school'">
            <v-text-field v-model="accountData.fax" outlined dense label="Fax"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="userType == 'school'">
            <v-text-field v-model="accountData.mailbox" outlined dense label="Mailbox"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="userType == 'school'">
            <v-text-field v-model="accountData.expiry_date" outlined dense label="Expiry Date"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="userType == 'school'">
            <v-text-field v-model="accountData.id_type" outlined dense label="Id Type"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="userType == 'school'">
            <v-text-field v-model="accountData.id_number" outlined dense label="Id Number"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="userType == 'school'">
            <v-text-field v-model="accountData.commercial_registration_number" outlined dense
              label="Commercial Registration Number"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="userType == 'school'">
            <v-text-field v-model="accountData.educational_transport_operation_card_number" type="number" value=0
              outlined dense label="Educational Transport Operation Card Number"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.license_number" outlined dense
              label="License"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.license_history" outlined dense
              label="License History"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.educational_transport_operation_card_number" outlined
              type="number" value="0" dense label="Educational Transport Operation Number"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.educational_transport_operating_card_expiry_date"
              outlined dense label="Educational Transport Operating Card Expiry Date"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.driver_license_expiry_date" outlined dense
              label="Driver License Expiry Date"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.vehicle_registration_license_attachment" outlined
              dense label="Vehicle Registration License Attachment"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.vehicle_registration_expiry_date" outlined dense
              label="Vehicle Registration Expiry Date"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.is_vehicle_owner" outlined dense
              label="Is Vehicle Owner"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.vehicle_owner_name" outlined dense
              label="Vehicle Owner Name"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.id_or_cr_number" outlined dense
              label="ID or CR Number"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.brand" outlined dense label="Brand"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.model" outlined dense label="Model"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.vehicle_color" outlined dense
              label="Vehicle Color"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.year_of_manufacture" outlined dense
              label="Year of Manufacture"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.plate_number" outlined dense
              label="Plate Number"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.vin" outlined dense label="VIN"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'driver' || userType == 'admin'">
            <v-text-field v-model="accountData.driver_information.vehicle_occupancy" outlined dense
              label="Vehicle Occupancy"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="userType == 'admin'">
            <v-select v-model="accountData.school_id" :items="accountData.facilities" item-text="name" item-value="id"
              outlined dense label="Select Facility"></v-select>
          </v-col>

          <v-col cols="12" md="6" v-if="userType == 'school'">
            <v-text-field v-model="accountData.educational_transport_operation_card_expiry_date" outlined dense
              label="Educational Transport Operation Card Expiry Date"></v-text-field>
          </v-col>



          <v-col cols="12">
            <v-btn color="primary" class="me-3 mt-4" @click="saveUser">
              Save changes
            </v-btn>
            <v-btn color="secondary" outlined class="mt-4" @click="cancel">
              Cancel
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>

import AvatarImageComponent from '../../../components/AvatarImageComponent.vue'
import { mdiAlertOutline, mdiCloudUploadOutline } from "@mdi/js";
import { adminProfileStore } from "@/utils/helpers";

export default {
  components: {
    AvatarImageComponent
  },
  setup() {
    return { adminProfileStore }
  },
  props: {
    accountData: {
      type: Object,
      default: () => { },
    },
    userType: {
      type: String,
      default: () => { },
    },
  },
  data() {
    return {
      valid: true,
      nameRules: [(v) => !!v || "Name is required"],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      phoneRules: [
        v => /^(|\d)+$/.test(v) || 'Phone must be valid',
      ],
      statuses: [
        { status: "Active", value: 1 },
        //{ status: "Pending", value: 2 },
        { status: "Suspended", value: 3 },
      ],
      roles: [
        { role: "Admin", value: 1 },
        { role: "School", value: 2 },
        { role: "Driver", value: 3 },
        { role: "Parent", value: 4 },
        { role: "Guardian", value: 5 },
        { role: "Student", value: 6 }
      ],
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
      },
    };
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    saveUser() {
      if (!this.validate()) return;
      this.$emit("save-user-info");
    },
    cancel() {
      this.$router.go(-1);
    }
  },
};
</script>
